import { render } from "./FriendRequestCard.vue?vue&type=template&id=1d07321c&scoped=true"
import script from "./FriendRequestCard.vue?vue&type=script&lang=js"
export * from "./FriendRequestCard.vue?vue&type=script&lang=js"

import "./FriendRequestCard.vue?vue&type=style&index=0&id=1d07321c&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d07321c"]])

export default __exports__